module.exports = __webpack_public_path__ + "img/icon-holiday-gift.09b396d4.png";